import * as Yup from 'yup'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../Multiplatform/CampaignForms/fields'

export const getBudgetValidation = ({ remainingBudget, initialBudget, budgetType }) => {
  // In edit form we need to sum: remainingBudget + initialBudget, to represent the max value user can enter
  const maxBudget = initialBudget ? remainingBudget + initialBudget : remainingBudget

  if (remainingBudget || remainingBudget === 0) {
    return Yup.object({
      ...(budgetType === BUDGET_LIFETIME
        ? {
            [BUDGET_LIFETIME]: Yup.number()
              .required('Budget is required')
              .max(maxBudget, `Must be less than or equal to ${maxBudget}`)
          }
        : {
            [BUDGET_DAILY]: Yup.number().required('Budget is required')
          })
    })
  } else {
    return Yup.object({
      ...(budgetType === BUDGET_LIFETIME
        ? {
            [BUDGET_LIFETIME]: Yup.number().required('Budget is required')
          }
        : {
            [BUDGET_DAILY]: Yup.number().required('Budget is required')
          })
    })
  }
}
